import * as React from 'react';
import { StackChildren, Text } from '@doordash/design-language';

var Titles = function Titles(_ref) {
  var isSubtextFirst = _ref.isSubtextFirst,
      textAlign = _ref.textAlign,
      hasSmallTitle = _ref.hasSmallTitle,
      subtextStringToDisplay = _ref.subtextStringToDisplay,
      title = _ref.title,
      isBelow = _ref.isBelow,
      allowTitleWrapping = _ref.allowTitleWrapping,
      allowSubtextWrapping = _ref.allowSubtextWrapping;
  var subTextProps = {
    color: Text.Colors.TextTertiary,
    styles: hasSmallTitle ? Text.Styles.NavBarCollapsedSubtitle : Text.Styles.NavBarExpandedSubtitle,
    overflow: !allowSubtextWrapping ? Text.Overflows.Truncate : undefined,
    textAlign: textAlign
  };
  var hasSubtext = subtextStringToDisplay && typeof subtextStringToDisplay !== 'undefined';
  var renderParentTitle = isSubtextFirst && hasSubtext;
  var renderSubtext = !isSubtextFirst && hasSubtext;
  return /*#__PURE__*/React.createElement(StackChildren, {
    size: isBelow ? StackChildren.Sizes.XxSmall : StackChildren.Sizes.None
  }, renderParentTitle && /*#__PURE__*/React.createElement(Text, subTextProps, subtextStringToDisplay), /*#__PURE__*/React.createElement(Text, {
    textAlign: textAlign,
    tag: "h2",
    styles: hasSmallTitle ? Text.Styles.NavBarCollapsedTitle : Text.Styles.NavBarExpandedTitle,
    overflow: !allowTitleWrapping ? Text.Overflows.Truncate : undefined
  }, title), renderSubtext && /*#__PURE__*/React.createElement(Text, subTextProps, subtextStringToDisplay));
};

export default Titles;